import { createMultiStyleConfigHelpers, inputAnatomy } from "~/foundation/Chakra";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
	field: {
		_placeholder: {
			color: "primary.aramcoGrey"
		},
	},
});

export const Input = defineMultiStyleConfig({ baseStyle })
